import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20388 13561"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#322d2c}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M14189 11273c-178-724-494-1534-1049-2224 294-642 632-1085 840-1322 1846 1291 3730 393 4406-14 1049 1130 1251 2836 1288 3559l-5485 1zm-7567 1580c126-1903 996-3096 1392-3546 1846 1291 3729 394 4405-13 1050 1128 1251 2835 1288 3559H6622zm-440-1581-5462 1c125-1903 994-3095 1391-3546 1846 1291 3729 393 4405-14 363 389 622 848 810 1311-351 436-839 1184-1144 2248zm14205 365c4-121 76-2990-1718-4637-125-116-317-124-453-20-21 16-2107 1588-4048 2-134-109-325-105-455 7-42 36-612 546-1108 1528-114-50-251-36-355 43-85 65-2117 1580-4049 2-95-77-219-96-330-62-249-536-593-1061-1071-1500-126-116-317-124-453-20-21 16-2107 1588-4049 2-134-109-325-105-454 7-74 64-1801 1603-1844 4633-1 94 35 186 102 253 66 68 156 105 251 105l5668-1c-66 378-112 783-118 1223-2 95 35 186 101 253 67 68 157 106 252 106l7811-2c191 0 347-151 353-341 2-50 14-550-90-1238l5704-1c190 0 347-152 353-342z"
        className="fil0"
      />
      <path
        d="M17990 5215c-497 499-1159 774-1861 774-1453 0-2635-1184-2635-2639-1-705 274-1368 772-1868 498-499 1160-774 1863-775 1452 0 2633 1185 2634 2641 0 704-274 1367-773 1867zm-5966 1580c-498 500-1159 775-1861 775h-1c-1453 0-2635-1185-2635-2640-1-705 274-1368 773-1867 498-500 1159-776 1862-776 1452 0 2634 1185 2635 2641 0 704-275 1367-773 1867zM6121 5215c-498 499-1159 774-1861 774h-1c-1452 0-2635-1184-2635-2639 0-705 275-1368 772-1868 499-499 1161-774 1863-775 1452 0 2634 1185 2635 2641 0 704-274 1367-773 1867zM16129 0c-892 0-1731 349-2362 983-526 528-852 1200-947 1927-611-806-1573-1329-2658-1329-891-1-1730 349-2361 982-88 87-169 179-245 275C7309 1233 5927 0 4259 0c-891 0-1730 349-2361 983-631 632-979 1474-979 2367 0 1845 1499 3347 3340 3347h1c891-1 1729-349 2360-982 87-88 168-180 244-275 247 1603 1630 2837 3298 2837h1c891 0 1730-349 2359-982 528-528 853-1201 948-1927 612 805 1573 1329 2659 1329 891-1 1730-349 2361-982 631-634 979-1474 978-2368 0-1845-1499-3347-3339-3347z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
